export { default } from './TagerInfo';
